import { render, staticRenderFns } from "./AppointmentTrend.vue?vue&type=template&id=6dacf221&"
import script from "./AppointmentTrend.vue?vue&type=script&lang=js&"
export * from "./AppointmentTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports